import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { GeneralErrorMessagePanel, Message, Spinner } from '@ecster/components';
import { i18n } from '@ecster/i18n';
import { createSession, deleteSession, dismissCreateSessionError, getSession, resetLoginState } from './redux/actions';
import { LoginFormSENETS } from './index';
import { getCustomerProperty } from '../customer/redux/getCustomerProperty';

import { GatewayContext } from '../../context/gateway-context';

class LoginForm extends Component {
    static contextType = GatewayContext;

    renderForm(loginForm) {
        const { createSessionError, getCustomerPropertyLoginMypagesError } = this.props;

        if (createSessionError || getCustomerPropertyLoginMypagesError) {
            return this.renderSessionError();
        }

        return <>{loginForm}</>;
    }

    renderSessionError() {
        const { createSessionError, getCustomerPropertyLoginMypagesError, clearState } = this.props;

        const error = createSessionError || getCustomerPropertyLoginMypagesError;

        return (
            <div className="max-w-[500px] m-auto">
                <GeneralErrorMessagePanel
                    header={i18n('general.error.general.header')}
                    body={i18n('general.error.general.body')}
                    error={error}
                    isFatal
                    dismissError={clearState}
                    onButtonClick={clearState}
                    buttonText={i18n('general.back')}
                    isLink
                />
            </div>
        );
    }

    render() {
        const { createSessionError, dismissCreateSessionError, ...rest } = this.props;
        const { value } = this.context;
        const { isLoading } = value;

        return isLoading ? (
            <Spinner isVisible isCenterX id="login--gui-spinner" />
        ) : (
            this.renderForm(<LoginFormSENETS {...rest} />)
        );
    }
}

LoginForm.propTypes = {
    resetLoginState: PropTypes.func.isRequired,
    person: PropTypes.object,

    loginProgress: PropTypes.object.isRequired,
    loginStatus: PropTypes.object.isRequired,

    createSession: PropTypes.func.isRequired,
    dismissCreateSessionError: PropTypes.func.isRequired,

    createSessionPending: PropTypes.bool.isRequired,
    createSessionError: PropTypes.object,

    getSession: PropTypes.func.isRequired,
    getSessionPending: PropTypes.bool.isRequired,
    getSessionError: PropTypes.object,

    deleteSession: PropTypes.func.isRequired,
    clearState: PropTypes.func.isRequired,

    getCustomerProperty: PropTypes.func.isRequired,
    getCustomerPropertyLoginMypagesError: PropTypes.object,

    userIsCustomer: PropTypes.bool,
    isReviewMode: PropTypes.bool.isRequired,
};

LoginForm.defaultProps = {
    person: undefined,
    userIsCustomer: undefined,
    createSessionError: undefined,
    getSessionError: undefined,
    getCustomerPropertyLoginMypagesError: null,
};

/* istanbul ignore next */
function mapStateToProps({
    authentication: {
        createSessionError,
        createSessionPending,
        getSessionError,
        getSessionPending,
        loginProgress,
        loginStatus,
        person,
    },
    common: { isReviewMode },
    customer: { LOGIN_MYPAGES, getCustomerPropertyLoginMypagesError },
}) {
    return {
        isReviewMode,
        loginProgress,
        loginStatus,
        person,
        userIsCustomer: LOGIN_MYPAGES,
        getCustomerPropertyLoginMypagesError,
        createSessionPending,
        createSessionError,
        getSessionPending,
        getSessionError,
    };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
    return {
        createSession: data => {
            dispatch(createSession(data));
        },
        deleteSession: key => {
            dispatch(deleteSession(key));
        },
        dismissCreateSessionError: () => {
            dispatch(dismissCreateSessionError());
        },
        resetLoginState: () => {
            dispatch(resetLoginState());
        },
        getSession: bankIdSuccessData => {
            dispatch(getSession(bankIdSuccessData));
        },
        getCustomerProperty: (customerId, propertyName) => {
            dispatch(getCustomerProperty(customerId, propertyName));
        },
        clearState: function clearState(isReviewMode) {
            return dispatch({
                type: 'CLEAR_STATE',
                isCustomer: true,
                justLoggedOut: false,
                isReviewMode,
            });
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
